import { PackageIcon } from 'lucide-react'

import { Button } from '@/components/ui'
import { cn, formatNumber } from '@/utils'
import { useCreditBankMutating } from '../../creditBankStore'
import { useCheckout } from '../../hooks'
import type { CreditBundle, Wallet } from '../../types'
import { formatPerUnit, formatPrice, grantOf, UNIT_NOUN } from './pricing'

export const BundleCard = ({
  wallet,
  bundle,
  isBestValue,
}: {
  wallet: Wallet
  bundle: CreditBundle
  isBestValue: boolean
}) => {
  const { buyCredits } = useCheckout()
  const isMutating = useCreditBankMutating()

  return (
    <div
      className={cn(
        'relative flex flex-col rounded-xl border bg-white p-5',
        isBestValue && 'border-brand ring-1 ring-brand',
      )}
    >
      {isBestValue && (
        <span className="absolute -top-2.5 right-4 rounded-full bg-primary px-2 py-0.5 text-xs font-medium text-primary-foreground">
          Best value
        </span>
      )}

      <div className="mb-5 bg-brand/10 flex size-11 shrink-0 items-center justify-center rounded-full">
        <PackageIcon className="size-5 text-brand" aria-hidden="true" />
      </div>

      <div className="text-3xl font-bold tracking-tight">
        {formatNumber(grantOf(wallet, bundle))}
      </div>
      <div className="text-muted-foreground font-medium">
        {UNIT_NOUN[wallet]}s
      </div>

      <div className="mt-4 text-2xl font-semibold">{formatPrice(bundle)}</div>
      <div className="text-xs text-muted-foreground">
        {formatPerUnit(wallet, bundle)}
      </div>

      {bundle.features.length > 0 && (
        <ul className="text-muted-foreground mt-3 space-y-1 text-xs">
          {bundle.features.map((feature) => (
            <li key={feature}>• {feature}</li>
          ))}
        </ul>
      )}

      <div className="mt-10 flex-1" />
      <Button onClick={() => buyCredits(bundle.priceId)} disabled={isMutating}>
        Select package
      </Button>
    </div>
  )
}
